import { LANGUAGE } from '../../components/i18n/languages';
import en from './en';
import mn from './mn';
import ru from './ru';

const root = {
  [LANGUAGE.MN]: mn,
  [LANGUAGE.EN]: en,
  [LANGUAGE.RU]: ru,
};

export default root;